<template>
<div class="col-12">
    <a href="javascript:window.print()" class="print-button">Cetak Report</a>
    <br />
    <div class="form-group">
        <h2>Penilaian Persediaan</h2>
        <label>Tanggal : {{ moment(this.$route.query.fromDate).format('L') }} - {{ moment(this.$route.query.toDate).format('L') }}</label>
    </div>
    <br />
    <app-common-report-template :elements="elements" :collections="iv"></app-common-report-template>
</div>
</template>

<script>
import api from '../../../services/api'
import AppCommonReportTemplate from '../../../components/AppCommonReportTemplate.vue'

export default {
    data() {
        return {
            elements: {
                header: [],
                group: false,
                groupHeader: [
                    [
                        {
                            label: 'Kode Produk',
                            column: 'productCode',
                            width: '3'
                        },
                        {
                            label: 'Nama Produk',
                            column: 'productName',
                            width: '4',
                        },
                        {
                            label: 'Merek',
                            column: 'brandName',
                            width: '4',
                        }    
                    ]
                ],
                content: [
                    {
                        title: 'Nama Produk',
                        column: 'productName',
                        type: 'text'
                    },
                    {
                        title: 'Merek',
                        column: 'brandName',
                        type: 'text'
                    },
                    {
                        title: 'Tanggal Pembelian',
                        column: 'purchaseDate',
                        type: 'date'
                    },
                    {
                        title: 'Harga Beli',
                        column: 'purchasePrice',
                        type: 'text'
                    },
                    {
                        title: 'Tanggal Penjualan',
                        column: 'sellDate',
                        type: 'date'
                    },
                    {
                        title: 'Harga Jual',
                        column: 'sellPrice',
                        type: 'text'
                    },
                    {
                        title: 'Profit',
                        column: 'profit',
                        type: 'text'
                    },
                ],
                contentFooter: [
                    {
                        span: 2,
                        title: 'Total',
                        bold: true
                    },
                    {
                        column: 'totalPurchase',
                        bold: true
                    },
                    { },
                    {
                        column: 'totalSell',
                        bold: true
                    },
                    { }
                ]
            },
            iv: { }
        }
    },
    components: {
        AppCommonReportTemplate
    },
    async created() {
        this.elements.group = (this.$route.query.productId === '') ? true : false
        const ivApi = api('report/inventory-valuation')
        const query = {
            params: {
                ...this.$route.query
            }
        }
        this.iv = await ivApi.getWithQuery(query)
    }
}
</script>